export const SOUNDS = {
  CLICK: '/sounds/click_general.mp3',
  HOVER: '/sounds/hover.mp3',
  CLICK_CLOSE: '/sounds/click_close.mp3',
  CLICK_MINIMIZE: '/sounds/click_minimize.mp3',
  CLICK_RESIZE_MAXIMIZE: '/sounds/click_resize_maximize.mp3',
  CLICK_RESIZE_MINIMIZE: '/sounds/click_resize_minimize.mp3',
  CLICK_FOLDER: '/sounds/click_folder.mp3',
  PLAY_PAUSE: '/sounds/play_pause.mp3',
  NOTIFICATION: '/sounds/notification.mp3',
} as const;

export type SoundKey = keyof typeof SOUNDS;
